import { useNavigate } from "react-router-dom";
import { RiErrorWarningLine } from "react-icons/ri";
import { FranchiseLogo } from "../../components/others/FranchiseBranding";

const Error404 = () => {

    const navigate = useNavigate()

    const goToInicio = () => {
        navigate("/")
    }

    return (
        <div className="text-[#DF6865] flex flex-col justify-center">
            <div className="w-full bg-[#343030] py-6 px-12">
                <FranchiseLogo className="h-10" />
                <p className="text-white text-xs">Portal de Clientes</p>
            </div>
            <div className="flex flex-col align-center">
                <RiErrorWarningLine className="text-[#DF6865] mx-auto my-4 h-20 w-20" height="85px" width="85px" />
                <h1 className="text-5xl mx-auto font-bold my-4">Error 404</h1>
                <h3 className="text-2xl mx-auto font-bold my-4">No hemos encontrado la pagina que buscas</h3>
                <p className="text-xl text-[#000000] mx-auto font-normal my-4">Vuelve al inicio para seguir trabajando</p>
                <button
                    className="bg-[#DD6E6B] text-[#FFFFFF] text-sm mx-auto px-14 py-3.5 rounded-lg my-4 font-bold"
                    onClick={goToInicio}
                >
                    Inicio
                </button>
            </div>
        </div>
    )
}

export default Error404;